import { css } from 'styled-components';
export const BUTTON_SHADOW = css `
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
`;
export const CARD_SHADOW = css `
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
`;
